// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
[data-v-2d67fbbc] .van-tabs--line .van-tabs__wrap {
  height: auto;
  /* width: 80%; */
  margin-inline: auto;
}
[data-v-2d67fbbc] .van-tabs__nav {
  background-color: transparent !important;
  justify-content: space-between;
}
[data-v-2d67fbbc] .van-tab {
  flex: none;
}
.icon-container[data-v-2d67fbbc] {
  transition: height 0.05s ease-out, margin-bottom 0.05s ease-out;
}
.icon-container img[data-v-2d67fbbc] {
  transition: transform 0.05s ease-out, opacity 0.05s ease-out;
  transform-origin: center;
  will-change: transform, opacity;
}
[data-v-2d67fbbc] .van-popup {
  background: transparent;
}
[data-v-2d67fbbc] .home-popup {
  left: 0;
  right: 0;
  /* width: 100%; */
  margin-inline: auto;
  /* padding-inline: 1rem; */
}
[data-v-2d67fbbc] .van-overlay {
  display: none;
}
[data-v-2d67fbbc] .van-search {
  background-color: transparent;
}
[data-v-2d67fbbc] .van-search__content {
  background-color: transparent;
  padding-left: 0;
}
[data-v-2d67fbbc] .van-field__left-icon {
  display: none;
}
[data-v-2d67fbbc] .van-search__action {
  line-height: 1;
}
`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
